import AdyenView from 'components/pages/checkout/CheckoutView/Payment/paymentMethods/Adyen';
import KlarnaView from 'components/pages/checkout/CheckoutView/Payment/paymentMethods/Klarna';
import PropTypes from 'prop-types';
import React from 'react';
import { basketProps } from 'utils/proptypes/basket';

const paymentMethodViews = {
    'kco-v3': KlarnaView,
    'adyen-drop-in': AdyenView,
    'adyen-drop-in-orrefors': AdyenView,
};

const PaymentView = ({ paymentMethodId, tracking = {}, displayShipping }) => {
    const View = paymentMethodViews[paymentMethodId] || (() => null);
    return <View tracking={tracking} displayShipping={displayShipping} />;
};

PaymentView.propTypes = {
    displayShipping: PropTypes.bool,
    paymentMethodId: basketProps.paymentMethodId.isRequired,
    tracking: PropTypes.shape({
        trigger: PropTypes.bool,
        setTrigger: PropTypes.func,
    }),
};

export default PaymentView;
